export enum MarketingUrl {
    Main = '/',
    Test = '/test',
    ExpiredLink = '/expired',
    NotFound = '/not-found',
    Unsubscribe = '/unsubscribe',
    Preferences = '/preferences',
    OptIn = '/optin',
    Error = '/error',
}
